export default "__VITE_ASSET__DNdqrfXU__"